import { motion } from 'framer-motion';
import { FileCheck, Rocket, GraduationCap, RefreshCw } from 'lucide-react';
import { useLang } from '../../../context/LangContext';
import { GlassCard } from '../../shared/GlassCard';
import { fadeInUp, staggerContainer, staggerChild } from '../../../animations/variants';

const items = [
  { titleKey: "tarifs.clarte.1.title", descKey: "tarifs.clarte.1.desc", icon: FileCheck },
  { titleKey: "tarifs.clarte.2.title", descKey: "tarifs.clarte.2.desc", icon: Rocket },
  { titleKey: "tarifs.clarte.3.title", descKey: "tarifs.clarte.3.desc", icon: GraduationCap },
  { titleKey: "tarifs.clarte.4.title", descKey: "tarifs.clarte.4.desc", icon: RefreshCw },
];

export const ClarteAbsolue = () => {
  const { t } = useLang();

  return (
    <section data-testid="clarte-section" className="relative py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.div {...fadeInUp} className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-3">
            {t("tarifs.clarte.title")}
          </h2>
          <p className="text-neutral-400 text-lg">{t("tarifs.clarte.subtitle")}</p>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
        >
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div key={i} variants={staggerChild}>
                <GlassCard className="p-6 h-full text-center" hover={true}>
                  <Icon size={24} className="text-brand-green mx-auto mb-4" strokeWidth={1.5} />
                  <h3 className="text-base font-semibold text-white mb-2">{t(item.titleKey)}</h3>
                  <p className="text-sm text-neutral-500 leading-relaxed">{t(item.descKey)}</p>
                </GlassCard>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
